import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { initialState } from './model'
import { ConfigData } from '../../../sagas/app/config/config.mapper'
import { ERRORS } from '../../../constants/errors'
import { AvailabilityResponse } from '../../../types'

export const app = createSlice({
  initialState,
  name: 'app',
  reducers: {
    getSaveReturnUrl: () => {},
    prefillForm: (_state, _action: PayloadAction<string>) => {},
    resetApplication: state => {
      state.flowId = ''
    },
    setAppReady: state => {
      state.appReady = true
    },
    setAvailability: (state, { payload }: PayloadAction<AvailabilityResponse>) => {
      state.availability = {
        outageEnd: payload.outageEnd,
        outageStart: payload.outageStart,
        status: payload.status,
      }
    },
    setEnvironmentSuccess: (state, action: PayloadAction<ConfigData>) => ({
      ...state,
      ...action.payload,
    }),
    setFlowId: (state, action: PayloadAction<string>) => {
      state.flowId = action.payload
    },
    setSaveReturnUrl: (state, action: PayloadAction<string>) => {
      state.saveReturnUrl = action.payload
    },
    setSessionExpired: state => {
      state.sessionExpired = true
    },
    showCentralErrorModal: (_state, _action: PayloadAction<ERRORS>) => {},
  },
})

export const appActions = app.actions

export default app.reducer
